import TBodyRow from './TBodyRow';

interface IProps {
  moduleData: any;
  handleDelete: any;
  isView: boolean;
  machineData: any;
  breakdownData: any;
  tabValue: any;
}

const TBody = ({
  moduleData,
  isView,
  handleDelete,
  machineData,
  breakdownData,
  tabValue,
}: IProps) => {
  return (
    <tbody>
      {moduleData?.map((item: any, index: number) => (
        <TBodyRow
          {...{
            item,
            index,
            isView,
            handleDelete,
            machineData,
            breakdownData,
            moduleData,
          }}
        />
      ))}
    </tbody>
  );
};

export default TBody;
